
export function isCached(item) {
  // TODO: Add other checks here for caching
  return !!item
}

export function isCachedCollection(collection) {
  return collection && Object.keys(collection).length > 0
}

export function isCachedItem(collection, key) {
  return isCachedCollection(collection) && isCached(collection[key])
}
